import React from 'react';

import { Card, Box, Text, Button } from 'wix-style-react';

export interface FinanceOptionProps {
  title: string;
  description: string;
  ctaText: string;
  onActionClicked?(): void;
  financeId: string;
}

export const FinanceOptionCard: React.FC<FinanceOptionProps> = (props) => {
  const { title, description, ctaText, onActionClicked, financeId } = props;
  return (
    <Box height="160px">
      <Card stretchVertically>
        <Box direction="vertical" padding="24px">
          <Box>
            <Text weight="bold" dataHook={`finance-option-${financeId}-title`}>
              {title}
            </Text>
          </Box>
          <Box height="36px" marginTop={1}>
            <Text
              dataHook={`finance-option-${financeId}-description`}
              size="small"
              weight="thin"
              secondary
            >
              {description}
            </Text>
          </Box>
          <Box marginTop={2}>
            <Button
              dataHook={`finance-option-${financeId}-action`}
              priority="secondary"
              size="small"
              onClick={onActionClicked}
            >
              {ctaText}
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
